var _defs, _rect, _path, _polygon, _polygon2, _rect2, _path2, _path3, _path4, _polygon3, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRtltoday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 626.57 225.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e00f22;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_rtltoday_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 626.57,
    height: 225.57,
    rx: 16.01,
    ry: 16.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.64,101.82h4c5.79,0,7.15-6.18,7.15-12.22,0-11.7-4.21-12.25-11.14-12Zm37.51,60.54h-23a13,13,0,0,1-3.53-7.15c-.35-8.84.1-21.4-.48-27.56s-1.89-10.15-6.64-10.57H58.66v45.28H35.41V62.06H67.16c16.65,0,25.57,5.86,25.57,24.27,0,14.49-4.79,17.2-13.34,21.72h0c5.69,1.47,12.59,6.32,12.92,13.27.58,8-.45,26.6.73,33,0,0,1.77,6.36,3.11,8.05"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.79 62.06 142.99 62.06 142.99 78.69 127.15 78.69 127.15 162.36 104.19 162.36 104.19 78.69 88.79 78.69 88.79 62.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.77 162.36 145.77 62.06 168.71 62.06 168.71 146.28 193.02 146.28 193.02 162.36 145.77 162.36"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 232.94,
    y: 30.08,
    width: 3.13,
    height: 167.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.37,162.36V62.06h35q17.7,0,25.43,10.39,7.86,10.83,7.87,36.53,0,29.49-6.18,40.31Q446,162.36,424,162.36ZM415,79.48v65.46h6.32q8.7,0,11.52-5.9,3.22-6.89,3.23-28.52,0-18.83-2.67-24.93t-11.8-6.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.42,162.36,482,62.06h29.5l25,100.3H512.05l-3.65-19.11h-24l-3.51,19.11ZM504.88,125l-8.56-44.67H496L487.75,125Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.55,162.36V122.88L517.12,62.06h26.13l11.24,37.22h.28l11.52-37.22h25.28l-25.42,60.82v39.48Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "270.55 62.06 325.01 62.06 325.01 78.69 309.1 78.69 309.1 162.36 286.03 162.36 286.03 78.69 270.55 78.69 270.55 62.06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.79,112.21q0,25-4.87,35.14-7.31,15-29.06,15-20.82,0-28.12-13.52-5.81-10.54-5.81-36.63t5.81-36.63Q332,62.06,352.86,62.06q21.76,0,29.06,15Q386.78,87.2,386.79,112.21Zm-44.34,0q0,17.3.54,21,1.89,14.06,9.73,14.06,8.11,0,10-13.93.52-3.64.54-21.08t-.54-21.09q-1.91-13.92-10-13.92-7.83,0-9.73,14.06Q342.45,94.91,342.45,112.21Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRtltoday);
export default __webpack_public_path__ + "static/media/logo_rtltoday.cdc67fcc2e2930e83f5e44b4331e65bc.svg";
export { ForwardRef as ReactComponent };